import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
//
//
//option {label:,value:}
export default {
  name: 'JSelectMultiple',
  props: {
    placeholder: {
      type: String,
      default: '',
      required: false
    },
    value: {
      type: String,
      required: false
    },
    readOnly: {
      type: Boolean,
      required: false,
      default: false
    },
    options: {
      type: Array,
      required: true
    },
    triggerChange: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      arrayValue: !this.value ? [] : this.value.split(",")
    };
  },
  watch: {
    value: function value(val) {
      if (!val) {
        this.arrayValue = [];
      } else {
        this.arrayValue = this.value.split(",");
      }
    }
  },
  methods: {
    onChange: function onChange(selectedValue) {
      if (this.triggerChange) {
        this.$emit('change', selectedValue.join(","));
      } else {
        this.$emit('input', selectedValue.join(","));
      }
    }
  }
};